module.exports = __webpack_public_path__ + "img/t_bty.fbad803a.svg";